import { ReactNode, createContext, useContext } from "react";

const ContextMenuCloseContext = createContext<() => void>(() => undefined);

export const ContextMenuCloseProvider = ({ closeMenu, children }: { closeMenu: () => void; children: ReactNode }) => {
  return <ContextMenuCloseContext.Provider value={closeMenu}>{children}</ContextMenuCloseContext.Provider>;
};

export const useContextMenuClose = () => useContext(ContextMenuCloseContext);
